import ArrowLeftIcon from '../../../assets/img/arrow-left.svg';
import BackspaceIcon from '../../../assets/img/backspace.svg';
import CalendarIcon from '../../../assets/img/calendar.svg';
import CheckIcon from '../../../assets/img/check.svg';
import ChevronIcon from '../../../assets/img/chevron.svg';
import ClockIcon from '../../../assets/img/clock.svg';
import CrossIcon from '../../../assets/img/cross.svg';
import DialPadIcon from '../../../assets/img/dial-pad.svg';
import DialPadActiveIcon from '../../../assets/img/dial-pad-active.svg';
import DotsIcon from '../../../assets/img/dots.svg';
import EditIcon from '../../../assets/img/edit.svg';
import LeadIcon from '../../../assets/img/lead.svg';
import MagnifyIcon from '../../../assets/img/magnify.svg';
import MeetingIcon from '../../../assets/img/meeting.svg';
import MicroIcon from '../../../assets/img/micro.svg';
import MicroMuteIcon from '../../../assets/img/micro-mute.svg';
import NotesIcon from '../../../assets/img/notes.svg';
import OfflineIcon from '../../../assets/img/offline.svg';
import PhoneIcon from '../../../assets/img/phone.svg';
import PlayIcon from '../../../assets/img/play.svg';
import ReloadIcon from '../../../assets/img/reload.svg';
import RemoveIcon from '../../../assets/img/remove.svg';
import RemoveDisabledIcon from '../../../assets/img/remove-disabled.svg';
import SalesforceIcon from '../../../assets/img/salesforce.svg';
import TrashIcon from '../../../assets/img/trash.svg';

const ICON_BY_NAME_MAP = {
  'arrow-left': ArrowLeftIcon,
  backspace: BackspaceIcon,
  calendar: CalendarIcon,
  check: CheckIcon,
  chevron: ChevronIcon,
  clock: ClockIcon,
  cross: CrossIcon,
  'dial-pad': DialPadIcon,
  'dial-pad-active': DialPadActiveIcon,
  dots: DotsIcon,
  edit: EditIcon,
  lead: LeadIcon,
  magnify: MagnifyIcon,
  meeting: MeetingIcon,
  micro: MicroIcon,
  'micro-mute': MicroMuteIcon,
  notes: NotesIcon,
  offline: OfflineIcon,
  phone: PhoneIcon,
  play: PlayIcon,
  reload: ReloadIcon,
  remove: RemoveIcon,
  'remove-disabled': RemoveDisabledIcon,
  salesforce: SalesforceIcon,
  trash: TrashIcon,
};

export const Icon = ({ alt = 'icon', name, ...props }) => {
  return <img alt={alt} src={ICON_BY_NAME_MAP[name]} {...props} />;
};
